import FormText from '../FormText/FormText';
import config from '../../config';
import Dropdown from '../Dropdown/Dropdown';
import {
  capitalizeFirstLetter,
  formatDatetime,
  arraysToObject
} from '../../utils';

export function lookupDefaultStatus(initialStatus) {
  if (initialStatus !== undefined) {
    const defaultValueObj =
      config.defaultValueByStatus[initialStatus['Status']];
    if (typeof defaultValueObj === 'string') {
      return defaultValueObj;
    }
    return defaultValueObj[initialStatus['Detailed Status']];
  }
}

export function formatInputOptions(
  tableName,
  rowName,
  rowValue,
  handleSelectedChange
) {
  if (tableName in config.tables) {
    const inputOptions = config.tables[tableName]['inputOptions'];
    if (rowName in inputOptions) {
      const rowType = inputOptions[rowName]['rowType'];
      const rowOptions = inputOptions[rowName]['rowOptions'];
      if (rowType === 'dropdown') {
        const dropdownOptions = arraysToObject(rowOptions, rowOptions);
        return (
          <Dropdown
            dropdownOptions={dropdownOptions}
            defaultValue={rowValue}
            handleSelectedChange={handleSelectedChange}
            handleArgs={[rowName]}
            selectMessage='Select'
            selectClassName='table-dropdown'
          />
        );
      } else if (rowType === 'text') {
        return (
          <FormText
            defaultValue={rowValue}
            handleSelectedChange={handleSelectedChange}
            handleArgs={[rowName]}
          />
        );
      } else if ((rowType === 'nullInt') & (rowValue === -9999)) {
        return <div className='uneditable-text'></div>;
      } else if (rowType === 'date' && rowValue !== '') {
        return (
          <div className='uneditable-text'>{formatDatetime(rowValue)}</div>
        );
      } else if (rowType === 'bool') {
        return (
          <div className='uneditable-text'>
            {capitalizeFirstLetter(String(rowValue))}
          </div>
        );
      } else if (rowType === 'link') {
        return (
          <a href={rowValue} target='_blank' rel='noreferrer'>
            Link
          </a>
        );
      } else if (rowType === 'email') {
        const title = config.tables[tableName].title;
        const pname = window.location.pathname;
        const systemID = pname.substring(pname.lastIndexOf('/') + 1);
        const subject = `NLD Refinement - ${title} (System ID: ${systemID})`;
        return <a href={`mailto:${rowValue}?subject=${subject}`}>{rowValue}</a>;
      }
    }
  }
  return <div className='uneditable-text'>{rowValue}</div>;
}
